import { BaseService } from "@/script/core/service/BaseService";
import { Failure, Success } from "@/script/core/service/DataService";
import { Dict } from "../entity/SystemEntity";

const globalDicts: Map<string, string> = new Map();

export class DictService extends BaseService {
  public loadChildItems(code: string, success: Success, failure?: Failure) {
    super.get("/api/sys/dict/child/items", { code }).then(
      function (result) {
        success(result.data.list);
      },
      function (error: Error) {
        if (failure) {
          failure(error);
        }
      }
    );
  }

  public init() {
    super.get("/api/sys/dict/list/full", {}).then(
      function (result) {
        const dicts = result.data as Dict[];
        dicts.forEach(item => {
          if (item.parentId === 0) {
            dicts.forEach(citem => {
              if (citem.parentId === item.id) {
                globalDicts.set(item.code + citem.itemKey!, citem.itemValue!);
              }
            });
          }
        });
      },
      function (error: Error) {
        console.error(error);
      }
    );
  }

}

export { globalDicts };
